import { Component } from 'react';
import { withRouter } from 'react-router-dom'
import NProgress from 'nprogress'

import Train from '../../services/train.js';
import Notification from '../../services/Notification.js';
import User from '../../services/User.js';

class ServiceAuthorization extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {}

    let service = props.match.params.service;

    let queryParams = new URLSearchParams(this.props.location.search);

    if (service === 'spotify') {
      let code = queryParams.get('code') || '';
      this.connectToSpotify(code);
    } else if (service === 'lastfm') {
      let token = queryParams.get('token') || '';
      this.connectToLastfm(token);
    } else if (service === 'google') {
      let code = queryParams.get('code') || '';
      this.connectToGoogle(code);
    }

  }

  connectToGoogle(code) {
    NProgress.start();
    Train.authorizeGoogle({code})
    .then((token) => {
      if (token) {
        User.startGoogleSession(token);
        NProgress.done();
        Notification.show('Successful google account validation', 'success');
        window.location = window.location.origin;
      } else {
        NProgress.done();
        Notification.show('Error validating google account', 'error');
        this.props.history.push('/');
      }
    })
    .catch((error) => {
        NProgress.done();
        Notification.show('Error validating google account', 'error');
        this.props.history.push('/');
    });
  }


  connectToLastfm(token) {
    NProgress.start();
    Train.authorizeLastfm({token})
    .then((data) => {
      if (data) {
        NProgress.done();
        Notification.show('Accounts have been connected', 'success');
        this.props.history.push(`/lastfm-users/${data.username}`);
      } else {
        NProgress.done();
        Notification.show('Error connecting to Last.fm', 'error');
        this.props.history.push(`/users/${User.getId()}/settings`);
      }
    })
    .catch((error) => {
      NProgress.done();
      Notification.show('Error connecting to Last.fm', 'error');
      this.props.history.push(`/users/${User.getId()}/settings`);
    });
  }

  connectToSpotify(code) {
    NProgress.start();
    Train.authorizeSpotify({code})
    .then((data) => {
      if (data) {
        NProgress.done();
        Notification.show('Accounts have been connected', 'success');
        this.props.history.push(`/users/${User.getId()}/settings`);
      } else {
        NProgress.done();
        Notification.show('Error connecting to Spotify', 'error');
        this.props.history.push(`/users/${User.getId()}/settings`);
      }
    })
    .catch((error) => {
      NProgress.done();
      Notification.show('Error connecting to Spotify', 'error');
      this.props.history.push(`/users/${User.getId()}/settings`);
    });
  }

  render() {
    return null;
  }

}

export default withRouter(ServiceAuthorization);



// WEBPACK FOOTER //
// ./src/js/components/user/ServiceAuthorization.jsx